import React from "react"

import { WithClassName } from "shared/types/WithClassName"

import { useCreateTeamMemberFormViewModel } from "../model/useCreateTeamMemberFormViewModel"
import { CreateTeamMemberFormModel } from "../types/CreateTeamMemberFormModel"
import { CreateTeamMemberFormView } from "./CreateTeamMemberFormView"

export interface SingleTeamInvitationFormProps
  extends WithClassName,
    CreateTeamMemberFormModel {
  id: string
  onInviteMore?: () => void
}

export const CreateSingleTeamMemberForm = React.memo(
  (props: SingleTeamInvitationFormProps) => {
    return (
      <CreateTeamMemberFormView {...useCreateTeamMemberFormViewModel(props)} />
    )
  }
)
